/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";
import { ModelComponentsBox } from "cms/models/layout/model-components-box";

const AddComponentDialog = (props) => {

    const { componentPosition, fieldName, handleCloseModal, open, setOpen } = props;
    const { t } = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            className='add-component-dialog'
            maxWidth='md'
            onClose={handleClose}
            open={open}
        >
            <div className='add-component-dialog-title'>
                <DialogTitle>
                    {t("Components.addComponent")}
                </DialogTitle>
                <IconButton
                    aria-label='close'
                    onClick={handleClose}
                >
                    <ClearIcon />
                </IconButton>
            </div>
            <DialogContent className='add-component-dialog-content'>
                <ModelComponentsBox
                    componentPosition={componentPosition}
                    dialogFieldName={fieldName}
                    handleCloseModal={handleCloseModal}
                    showActiveField={false}
                />
            </DialogContent>
        </Dialog>
    );
};

export { AddComponentDialog };
